import { render, staticRenderFns } from "./BaseTableNew.vue?vue&type=template&id=47e35a50"
import script from "./BaseTableNew.vue?vue&type=script&lang=js"
export * from "./BaseTableNew.vue?vue&type=script&lang=js"
import style0 from "./BaseTableNew.vue?vue&type=style&index=0&id=47e35a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports